import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Slide from '@mui/material/Slide';
import Alert from '@mui/material/Alert';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';

import { removeNotification } from '../notification/notificationReducer';
import notificationSelector from '../notification/notificationSelector';
import type { Notification as NotificationType } from '../types/notification';
import type { RootState, AppDispatch } from '../../store';

function Notification() {
  const dispatch: AppDispatch = useDispatch();
  const notifications = useSelector<RootState, NotificationType[]>(notificationSelector.getNotifications);
  const notification = notifications[0];

  const handleClose = (notificationId: string, reason?: SnackbarCloseReason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(removeNotification(notificationId));
  };
  if (notification == null) {
    return <></>;
  }

  return (
    <Snackbar
      key={notification.id}
      open={true}
      TransitionComponent={(props) => <Slide direction='up' {...props} />}
      autoHideDuration={notification.color === 'error' ? null : 6000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      onClose={(_, reason) => handleClose(notification.id, reason)}
    >
      <Alert
        onClose={() => handleClose(notification.id)}
        severity={notification.color}
        elevation={6}
        iconMapping={{
          error: <ErrorIcon />,
          info: <InfoIcon />,
          success: <CheckCircleIcon />,
          warning: <WarningIcon />,
        }}
        sx={{ width: '100%' }}
      >
        {notifications[0].message}
      </Alert>
    </Snackbar>
  );
}

export default Notification;
